export interface KISAUser {
  // DB Fields
  uid: number; // 고유 ID - Primary Key
  guid: string; // UUID
  name: string; // 이름
  loginID: string; // 로그인 ID
  loginPW: string; // 로그인 비밀번호
  userLevel: number; // 사용자 등급 ( 0 - None, 1 - 시스템 최고 관리자, 2 - 사업장 관리자, 3 - 사업장 관리자, 4 - 사업장 담당자, 5 - 자체감사 사용자, 6 - 일반)
  isDeleted: boolean; // 삭제 여부

  referenceYear: number; // 기준연도 - 2020-04-24 추가
  certification: string; // 자격증 이름 - 2020-04-24 추가

  companyName: string; // deprecated 사용되지 않음 삭제 예정
  department: string; // 부서명
  email: string; // 이메일

  entryDate: Date; // 생성일
  modifyDate: Date; // 마지막 수정일
  expireDate: Date; // 사용 만료일
  deleteDate: Date; // 삭제일

  // 와래 키
  creatorUID: number; // 생성자 uid
  modifierUID: number; // 마지막 수정자 uid
  ownerUID: number; // deprecated 소유자 uid / 사용되지 않음
  eqCompanyUID: number; // deprecated 사용되지 않음 삭제 예정

  // Non DB
  token: string; // 서버로 부터 받은 token값
}

// 초기값
export const initializeKisaUser: KISAUser = {
  uid: 0,
  guid: "",
  name: "",
  loginID: "",
  loginPW: "",
  userLevel: 5, // 5 - 자체감사 사용자
  isDeleted: false,

  referenceYear: 2000,
  certification: "",

  companyName: "", // deprecated 사용되지 않음 삭제 예정
  department: "",
  email: "",

  entryDate: new Date(),
  modifyDate: new Date(),
  expireDate: new Date(new Date().setFullYear(new Date().getFullYear() + 5)), // 현재로부터 5년 뒤
  deleteDate: new Date(1900, 1, 1),

  creatorUID: 0,
  modifierUID: 0,
  ownerUID: 0, // deprecated 사용되지 않음 삭제 예정
  eqCompanyUID: 0, // deprecated 사용되지 않음 삭제 예정

  token: "",
};

export const initializeUser = (): KISAUser => {
  return {
    uid: 0,
    guid: "",
    name: "",
    loginID: "",
    loginPW: "",
    userLevel: 5, // 5 - 자체감사 사용자
    isDeleted: false,
  
    referenceYear: 2000,
    certification: "",
  
    companyName: "", // deprecated 사용되지 않음 삭제 예정
    department: "",
    email: "",
  
    entryDate: new Date(),
    modifyDate: new Date(),
    expireDate: new Date(new Date().setFullYear(new Date().getFullYear() + 5)), // 현재로부터 5년 뒤
    deleteDate: new Date(1900, 1, 1),
  
    creatorUID: 0,
    modifierUID: 0,
    ownerUID: 0, // deprecated 사용되지 않음 삭제 예정
    eqCompanyUID: 0, // deprecated 사용되지 않음 삭제 예정
  
    token: "",
  }
}

export interface KISAUserListRequest {
  userToken?: string; // 사용자 식별 값
  page?: number; // 페이지 번호 (옵션 : 기본값 1)
  rowCount?: number; // 한 페이지에 표시되는 개수 (옵션 : 기본값 30)
  searchWord?: string; // 검색어 (옵션)
}
export interface KISAUserLoginRequest {
  loginID: string;
  loginPW: string;
  callback?: any; // 2021-11-26 SmokingScully 추가
}
